// src\externalApi\local.js
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const fetchData = async (url, method = "GET", body = null) => {
    const options = {
        method,
        headers: { "Content-Type": "application/json" },
        credentials: "include"
    };
    if (body) {
        options.body = JSON.stringify(body);
    }
    try {
        const response = await fetch(`${API_BASE_URL}${url}`, options);
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.detail || "Ошибка запроса");
        }
        return data;
    } catch (error) {
        console.error(`Ошибка при запросе ${url}:`, error);
        throw error;
    }
};
// Функция для обеспечения полного URL
const ensureFullUrl = (url) => {
    if (!url) return url;
    // Если URL уже начинается с http, оставляем как есть
    if (url.startsWith('http')) return url;
    // Если URL начинается с /, добавляем домен
    const domain = process.env.REACT_APP_SITE_DOMAIN;
    return `${domain}${url.startsWith('/') ? '' : '/'}${url}`;
};
const localApi = {
    // APOD (Создание и обновление компании)
    createCompany: (domain_name, username_tg, full_name) =>
        fetchData("/apod/company", "POST", { domain_name, username_tg, full_name }),
    upsertCompany: (companyData) => fetchData("/apod/company/upsert", "POST", companyData),
    editMessage: (user_id, text) => fetchData("/telegram/edit", "POST", { user_id, text }),
   
    // DB (Сотрудники и пользователи)
    getEmployee: (username) => fetchData(`/db/employee/${username}`),
    createUser: (userData) => fetchData("/db/user", "POST", userData),
    updateUser: (user_id, updateData) => fetchData(`/db/user/${user_id}`, "PUT", updateData),
   
    // Транзакции
    getTransactionStatus: (operation_id) => fetchData(`/db/transaction/status/${operation_id}`),
    getLatestTransaction: (user_id) => fetchData(`/db/transaction/latest/${user_id}`),
    createTransaction: (transactionData) => fetchData("/db/transaction", "POST", transactionData),
    updateTransaction: (transaction_id, updateData) => fetchData(`/db/transaction/${transaction_id}`, "PUT", updateData),
   
    // Поиск пользователей
    searchUsers: (searchParams) => fetchData("/db/users/search", "POST", searchParams),
   
    // ТОЧКА (Платежи и подписки)
    createPaymentReceipt: (amount, email, redirect_url = null, fail_redirect_url = null, user_id) =>
        fetchData("/tochka/payments/receipt", "POST", {
            amount,
            email,
            redirect_url: ensureFullUrl(redirect_url),
            fail_redirect_url: ensureFullUrl(fail_redirect_url),
            user_id
        }),
    createSubscriptionReceipt: (tranche_count, amount, client, items, redirect_url = null, fail_redirect_url = null, user_id) =>
        fetchData("/tochka/subscriptions/receipt", "POST", {
            tranche_count,
            amount,
            client,
            items,
            redirect_url: ensureFullUrl(redirect_url),
            fail_redirect_url: ensureFullUrl(fail_redirect_url),
            user_id
        }),
   
    // ТРЕКЕР (Задачи и пользователи)
    searchIssues: (summary) => fetchData("/tracker/issues/search", "POST", { summary }),
    createIssue: (issueData) => fetchData("/tracker/issues", "POST", issueData),
    getUsers: () => fetchData("/tracker/users"),
};
export default localApi;